import React from 'react';
import Modal from 'react-responsive-modal';
import { name, toggleModal } from 'signals/modal';

function BaseModal({ title, children, tag, size = 'big', onExit = () => { }, ...props }) {
    const onClose = () => {
        onExit();
        toggleModal({name: tag});
    };
    const isOpen = name.value[tag];
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            center={true}
            closeOnEsc={false}
            closeOnOverlayClick={false}
            blockScroll={false}
            classNames={{
                modal: `modals modal-${tag} popup-${size}`,
                overlay: `modal__overlay overlay-${tag}`,
                closeButton: `btn-close close-${tag}`,
                // modalAnimationIn: ``,
                // modalAnimationOut: `${effect[tag]?.animOut || effect.prize.animOut}`,
            }}
            // closeIcon={<div className="ico-close" />}
            showCloseIcon={false}
            focusTrapped={false}
            {...props}
        >
            <div
                className={`modal__container ${tag}`}
            // style={{ animationDelay: 300}}
            >
                {title && (
                    <div className={`modal__title ${tag}`}>
                        <div className={`title-${tag}`}></div>
                    </div>
                )}
                <div className={`modal__content ${tag}`}>{children}</div>
            </div>
        </Modal>
    );
}

export default BaseModal;
